<template>
    <div>
        <!-- Seller Products Listings -->
        <div v-if="showSellerProducts && sellerProducts.length > 0">
            <div class="header">
                <h1 class="mb-0">
                    {{ $t("sentence.announcementsOf") }}
                    <span class="font-weight-bold"> {{ username }} </span>
                    <p class="text-primary h4 mb-0">
                        ({{ sellerProducts.length }} {{ $t("sentence.announcement") }})
                    </p>
                </h1>
                <router-link v-if="authUser.id !== userId" class="btn btn-primary"
                    :to="{ name: 'BatchCreate', params: { id: userId } }">
                    {{ $t("sentence.createBatch") }}
                </router-link>
            </div>

            <div class="products-scroll-container">
                <div class="products-scroll-row">
                    <div class="product-item" v-for="product in sellerProducts" :key="product.id">
                        <ProductSingle :product="product" />
                    </div>
                </div>
            </div>
        </div>

        <!-- More Products -->
        <div v-if="showMoreProducts && moreProducts.length > 0" class="mb-md-4">
            <div class="header mt-3">
                <h1>{{ $t('product.more') }}</h1>
            </div>
            <div class="products-scroll-container">
                <div class="products-scroll-row">
                    <div class="product-item" v-for="product in moreProducts" :key="product.id">
                        <ProductSingle :product="product" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProductSingle from "@/components/templates/ProductSingle.vue";

export default {
    name: "ProductsListings",
    components: {
        ProductSingle
    },
    computed: {
        authUser() {
            return this.$store.state.user;
        },
    },
    props: {
        sellerProducts: {
            type: Array,
            default: () => []
        },
        moreProducts: {
            type: Array,
            default: () => []
        },
        username: {
            type: String,
            default: ''
        },
        userId: {
            type: [Number, String],
            default: ''
        },
        showSellerProducts: {
            type: Boolean,
            default: true
        },
        showMoreProducts: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style scoped>
/* Header Styles */
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.header h1 {
    font-size: 24px;
    font-weight: 600;
    color: var(--color-dark);
}

.see-more {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
    color: var(--color-dark);
    text-decoration: none;
}

/* Products Scroll Container */
.products-scroll-container {
    overflow-x: auto;
    padding-bottom: 0.5rem;
    scroll-behavior: smooth;
}

.products-scroll-row {
    display: flex;
    flex-wrap: nowrap;
    gap: 0.5rem;
}

.product-item {
    flex: 0 0 auto;
    width: 40%;
    padding: 0.25rem;
}

.products-scroll-container::-webkit-scrollbar {
    height: 6px;
}

.products-scroll-container::-webkit-scrollbar-thumb {
    background: var(--gray-300);
    border-radius: 3px;
}

@media (min-width: 576px) {
    .product-item {
        width: 18%;
    }
}
</style>